import { memo } from "react";

import { QuestionPlanCheckInAvailableDayOfTheWeek as Question } from "@/components/features/items/edit/plan/_shared/ui/components/term/check-in-available-day-of-the-week";

import { usePlanCheckInAvailableDayOfTheWeek } from "./hooks/use-check-in-available-day-of-the-week";

export const QuestionPlanCheckInAvailableDayOfTheWeek = memo(() => {
	const {
		checkInAvailableDayOfTheWeek,
		rawCheckInAvailableDayOfTheWeek,
		onSetCheckInAvailableDayOfTheWeek,
		isHolidayCheckInAvailable,
		onSetIsHolidayCheckInAvailable,
	} = usePlanCheckInAvailableDayOfTheWeek();

	return (
		<Question
			checkInAvailableDayOfTheWeek={checkInAvailableDayOfTheWeek}
			rawCheckInAvailableDayOfTheWeek={rawCheckInAvailableDayOfTheWeek}
			onSetCheckInAvailableDayOfTheWeek={onSetCheckInAvailableDayOfTheWeek}
			isHolidayCheckInAvailable={isHolidayCheckInAvailable}
			onSetIsHolidayCheckInAvailable={onSetIsHolidayCheckInAvailable}
		/>
	);
});

QuestionPlanCheckInAvailableDayOfTheWeek.displayName = "QuestionPlanCheckInAvailableDayOfTheWeek";
